import type { MeResponse, MeUser, MeUserMembership } from '../../shared/types/me'
import type { AnalyticsGlobalContext } from '../types'

/** Global keys from `GET /me` (first membership). Full catalog: `README.md`. */
export function sdrFieldsFromMe(me: MeResponse | null | undefined): Partial<AnalyticsGlobalContext> {
  if (!me?.user) {
    return {}
  }
  return { ...fromMeUser(me.user) }
}

function fromMeUser(user: MeUser): Partial<AnalyticsGlobalContext> {
  const m = firstMembership(user.memberships)
  const out: Partial<AnalyticsGlobalContext> = {}
  if (m) {
    if (m.id) {
      out.membership_number = String(m.id)
    }
    if (m.contractType) {
      out.membership_type = m.contractType
    }
    if (m.level?.label) {
      out.membership_tier = m.level.label
    }
    if (m.credits?.balance != null) {
      out.points_available = String(m.credits.balance)
    }
  }
  return out
}

function firstMembership(memberships: MeUser['memberships']): MeUserMembership | undefined {
  if (!memberships || memberships.length === 0) {
    return undefined
  }
  return memberships[0]
}
